import { useMemo } from 'react';

import { ProgressBarSectionsProps } from './progress-bar.type';
import { parseColor } from './utils';
import { Tooltip } from '../../';

export const ProgressBarSections = (props: ProgressBarSectionsProps) => {
  const { sections, total } = props;

  const filteredSections = useMemo(() => sections?.filter((s) => s.value > 0) ?? [], [sections]);
  const totalProgress = useMemo(() => sections?.reduce((acc, s) => acc + s.value, 0) ?? 0, [sections]);

  return (
    <>
      {filteredSections.map((section, index) => {
        const border = index === filteredSections.length - 1 && totalProgress === total ? '' : 'border-r-2';
        return (
          <div
            key={section.key}
            className={`border-white ${
              section.color ? parseColor(section.color) : 'bg-blue-500'
            } flex h-full ${border}`}
            style={{ width: `${(section.value / total) * 100}%` }}
          >
            {section.label && (
              <Tooltip
                title={section.label}
                containerClassName="flex-1"
                placement="bottom"
                offsetOptions={10}
                arrowPointAtCenter
                autoPlacementOptions={{
                  autoAlignment: true,
                  allowedPlacements: ['bottom', 'bottom-end', 'bottom-start'],
                }}
              >
                <div className="size-full"></div>
              </Tooltip>
            )}
          </div>
        );
      })}
    </>
  );
};
